module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/jmj0vM/tc-custom/9783988267894.jpg?1704425412042",
      "alt": "This image is the cover for the book The Dalrymples, Classics To Go"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Dalrymples, Classics To Go\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The Dalrymples by Agnes Giberne is a delightful exploration of the lives and relationships within the Dalrymple family. This intricately woven story captures the essence of family life with all its complexities, presenting readers with a touching and realistic portrait of family dynamics. With her keen insights into human nature and her ability to evoke emotion, Giberne ensures that readers will become deeply invested in the characters and their journey. The Dalrymples is more than just a novel; it's a mirror reflecting the very essence of family life. If you enjoy rich, character-driven narratives, The Dalrymples by Agnes Giberne is a must-read. Experience the joys and challenges of the Dalrymple family today! (Google)")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Agnes Giberne\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Agnes Giberne (19 November 1845 – 20 August 1939) was a prolific British novelist and scientific writer.  Her fiction was typical of Victorian evangelical fiction with moral or religious themes for children. She also wrote books on science for young people, a handful of historical novels, and one well-regarded biography.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    OTB ebook\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0